import React from 'react';
import { Modal, Tabs, Tooltip } from 'antd';
import { CustomerModel } from '@app/interfaces/customer';
import { FcDebt, FcViewDetails } from 'react-icons/fc';
import { MdWorkHistory } from 'react-icons/md';
import { ExportOutlined } from '@ant-design/icons';
import OverviewForm from './OverviewForm';
import { formatMoney } from '@app/utils/utils';
import PointsHistory from '../detail/PointsHistory';
import LedgerTransTable from '../components/LedgerTransTable';
import Overview from '../detail/Overview';
import DebitCustomer from '../detail/DebitCustomer';
import { FaSellsy } from 'react-icons/fa';
import CustomerPointsAlert from '../components/CustomerPointsAlert';

interface ModalProps {
  open: boolean;
  record: CustomerModel;
  onClose: () => void;
  source?: string;
  /** Mở từ form đơn: cho áp dụng điểm vào bill ngay trong popup. */
  onApplyPoints?: () => void;
  pointsApplied?: boolean;
}

const OverviewModal: React.FC<ModalProps> = ({ open, record, onClose, source, onApplyPoints, pointsApplied }) => {
  const title = `${record?.name} - ${record?.customer_code}`;

  return (
    <>
      <Modal open={open} onCancel={onClose} width={1000} style={{ top: 20 }} closable={true} footer={null}>
        <h3 className="tw-mb-4 tw-flex tw-items-center tw-gap-2.5">
          <span className="font-bold-weight">{title}</span>
          <Tooltip title="Mở trang chi tiết khách hàng">
            <a
              href={`/partners/customers/${record?.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="tw-inline-flex tw-items-center tw-align-middle tw-text-[15px] tw-text-primary tw-transition-[color,transform] tw-duration-200 tw-ease-[ease] hover:tw-scale-[1.15] hover:tw-text-primary"
              title="Mở trang chi tiết khách hàng"
            >
              <ExportOutlined />
            </a>
          </Tooltip>
          <span className="tw-italic tw-text-[#8c8c8c]">| {record?.store_name}</span>
        </h3>
        <h4 className="mb-4 text-right">
          Nợ:{' '}
          <span className="text-danger font-bold-weight me-1">{formatMoney(record?.debit_amount)}</span>{' '}
          | Tổng điểm: <span className="text-primary font-bold-weight me-1">{record?.points_summary?.balance ?? record?.number_of_points}</span> | Số lần
          mua: <span className="text-primary font-bold-weight me-1">{record?.number_of_orders}</span> | Tổng bán trừ trả
          hàng:{' '}
          <span className="text-primary font-bold-weight me-1">
            {formatMoney(record?.total_order_amount)}
          </span>
        </h4>

        <CustomerPointsAlert
          className="tw-mb-4"
          points={(record?.points_summary?.balance ?? record?.number_of_points) as number}
          reserved={record?.points_reserved}
          pointValue={record?.point_value}
          applied={pointsApplied}
          onApply={onApplyPoints}
        />

        <Tabs defaultActiveKey="1" size="middle" className="mb-3">
          <Tabs.TabPane
            tab={
              <span>
                <FcViewDetails /> Thông tin
              </span>
            }
            key="customerTabOverivew"
          >
            {source === 'order' ? (
              <Overview record={record} source={source} />
            ) : (
              <OverviewForm record={record} onClose={onClose} />
            )}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span>
                <FaSellsy /> Lịch sử bán/trả hàng
              </span>
            }
            key="customerTabSalesReturnHistory"
          >
            <LedgerTransTable record={record} />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span>
                <FcDebt /> Công nợ khách hàng
              </span>
            }
            key="customerTabDebit"
          >
            <DebitCustomer record={record} />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span>
                <MdWorkHistory /> Lịch sử tích điểm
              </span>
            }
            key="customerTabPointHistory"
          >
            <PointsHistory record={record} />
          </Tabs.TabPane>
        </Tabs>
      </Modal>
    </>
  );
};

export default OverviewModal;
